import { createCompoundComponent } from '../../utilities'
import { HorizontalGauge as BaseHorizontalGauge } from './HorizontalGauge'
import { HorizontalGaugeBar as Bar } from './HorizontalGaugeBar'
import { HorizontalGaugeIndicator as Indicator } from './HorizontalGaugeIndicator'

const HorizontalGauge = createCompoundComponent(BaseHorizontalGauge, {
  Bar,
  Indicator,
})

export { HorizontalGauge }
